import React, { useMemo } from 'react';
import {
  TEDEKBokforderSTATUSEnum,
  TEDEKBokforderTYPEnum,
  TEDEKBokforderU_UTBETALNINGSKATEGORIEnum,
} from '../../../../../../globalQueryTypes';
import { IEditMenuAction } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormUtils';
import {
  FormUpdateAssociatonType,
  getFormUpdateValue,
} from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/BusinessDataFormValueUtils';
import { mergeBusinessDataMutations } from '../../../../_Common/Components/BusinessCollectionComponents/BusinessDataForm/Utils/MergeBusinessDataMutations';
import { IValues } from '../../../../_StandardRutin/Mutations/ObjectMutations/ObjectUpdateMutationBase';
import {
  getBfoValidationErrors,
  getRowsDeleteObjects,
  getValuesForNewBokforder,
  isSendButtonHidden,
  saveRows,
} from '../Utils/BokforderUtils';

export const useBokforderEditMenuSendButton = (
  bokfgrupp: string | undefined,
  isNew: boolean | undefined,
  queriesLoading: boolean,
  userID: string | null,
  setRemoveRowsDialog: React.Dispatch<React.SetStateAction<boolean>>,
  setOnSendCallback: React.Dispatch<
    React.SetStateAction<{ callback: () => void }>
  >,
  utbetalningsKategori: TEDEKBokforderU_UTBETALNINGSKATEGORIEnum | null,
  type: TEDEKBokforderTYPEnum,
  setRemoveDialogWarningText?: React.Dispatch<React.SetStateAction<string>>
): IEditMenuAction => {
  return useMemo(
    () => ({
      id: 'sendButton',
      isDisabled: params => {
        return getBfoValidationErrors(params) || queriesLoading;
      },
      isHidden: isSendButtonHidden(userID ?? '', type),
      label: 'Skicka vidare',
      shortLabel: 'Skicka',
      icon: 'send',
      hideIconIfNotFloating: true,
      onClick: params => {
        if (isNew) {
          const newValues = getValuesForNewBokforder(
            TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST,
            bokfgrupp,
            userID,
            utbetalningsKategori,
            true,
            type
          );

          let updateValues = getRowsDeleteObjects(
            params.businessDataFormContext.formState.currentValues,
            true,
            true
          );

          updateValues = updateValues.concat(newValues);

          const unfullfilledRowsToRemove = getRowsDeleteObjects(
            params.businessDataFormContext.formState.currentValues,
            true,
            false
          );

          if (unfullfilledRowsToRemove.length > 0) {
            setRemoveRowsDialog(true);
            if (setRemoveDialogWarningText) {
              setRemoveDialogWarningText(
                'Vill du skicka bokföringsordern vidare för attest?'
              );
            }
            setOnSendCallback({
              callback: () => saveRows(params, updateValues),
            });
          } else {
            const mergedValues = mergeBusinessDataMutations(
              params.businessDataFormContext.formState.values ?? {},
              getFormUpdateValue(
                updateValues,
                params.businessDataFormContext.data ?? {}
              )
            );

            params.businessDataFormContext.saveForm(
              mergedValues,
              () => {
                params.selectDetail?.(null, true);
              },
              undefined,
              { suppressAddedIdSelection: true }
            );
          }
        } else {
          const date = new Date().toLocaleDateString('sv-SE');
          let values: IValues = {
            STATUS: TEDEKBokforderSTATUSEnum.VANTAR_PA_ATTEST,
            STATUS_DATUM: date,
          };

          if (
            params.businessDataFormContext?.data?.BESTALLD_DATUM == undefined
          ) {
            values = {
              ...values,
              BESTALLD_DATUM: date,
            };
          }

          const newValues: FormUpdateAssociatonType[] = [
            {
              operation: 'OwnFields',
              values: values,
            },
          ];

          const updateValues = getRowsDeleteObjects(
            params.businessDataFormContext.formState.currentValues,
            true,
            true
          );

          const unfullfilledRowsToRemove = getRowsDeleteObjects(
            params.businessDataFormContext.formState.currentValues,
            true,
            false
          );

          updateValues.push(newValues);
          if (unfullfilledRowsToRemove.length > 0) {
            setRemoveRowsDialog(true);
            if (setRemoveDialogWarningText) {
              setRemoveDialogWarningText(
                'Vill du skicka bokföringsordern vidare för attest?'
              );
            }
            setOnSendCallback({
              callback: () => saveRows(params, updateValues),
            });
          } else {
            const mergedValues = mergeBusinessDataMutations(
              params.businessDataFormContext.formState.values ?? {},
              getFormUpdateValue(
                updateValues,
                params.businessDataFormContext.data ?? {}
              )
            );

            params.businessDataFormContext.saveForm(
              mergedValues,
              () => {
                params.selectDetail?.(null, true);
              },
              undefined,
              { suppressAddedIdSelection: true }
            );
          }
        }
      },
    }),
    [
      bokfgrupp,
      isNew,
      queriesLoading,
      setOnSendCallback,
      setRemoveDialogWarningText,
      setRemoveRowsDialog,
      type,
      userID,
      utbetalningsKategori,
    ]
  );
};
